import { render, staticRenderFns } from "./ChildRelocationStep.vue?vue&type=template&id=62fa440b"
import script from "./ChildRelocationStep.vue?vue&type=script&lang=ts"
export * from "./ChildRelocationStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports